/**
 * Transforms MUI DataGrid `filterModel` into a MongoDB query filter
 * @param {Object} filterModel - The MUI DataGrid filterModel object
 * @returns {Object} MongoDB filter query
 */
export default function transformMuiFilterToMongoDB(filterModel) {
  const { items, logicOperator } = filterModel;

  if (!items || items.length === 0) {
    return {};
  }

  const mongoFilter = {};

  items.forEach((filter) => {
    const { field, operator, value } = filter;

    if (!value || !field) return;

    switch (operator) {
      case 'contains':
        mongoFilter[field] = { $regex: value, $options: 'i' };
        break;

      case 'equals':
        mongoFilter[field] = value;
        break;

      case 'doesNotEqual':
        mongoFilter[field] = { $ne: value };
        break;

      case 'startsWith':
        mongoFilter[field] = { $regex: `^${value}`, $options: 'i' };
        break;

      case 'endsWith':
        mongoFilter[field] = { $regex: `${value}$`, $options: 'i' };
        break;

      case 'isEmpty':
        mongoFilter[field] = { $exists: true, $eq: '' };
        break;

      case 'doesNotExist':
        mongoFilter[field] = { $exists: false };
        break;

      case 'isNotEmpty':
        mongoFilter[field] = { $exists: true, $ne: '' };
        break;

      case 'greaterThan':
        mongoFilter[field] = { $gt: value };
        break;

      case 'greaterThanOrEqual':
        mongoFilter[field] = { $gte: value };
        break;

      case 'lessThan':
        mongoFilter[field] = { $lt: value };
        break;

      case 'lessThanOrEqual':
        mongoFilter[field] = { $lte: value };
        break;

      default:
        console.warn(`Unsupported operator: ${operator}`);
    }
  });

  if (logicOperator === 'or') {
    return {
      $or: Object.entries(mongoFilter).map(([key, value]) => ({
        [key]: value,
      })),
    };
  }

  return mongoFilter;
}
